<div class="page-container">
  <div class="page-container__content">
    <div class="page-container__logo">
      <img src="assets/images/icon.png" alt="logo" />
    </div>
    <div class="page-container__text">
      <div>
        <h1>Oops</h1>
        <p>You are not authorized</p>
      </div>
    </div>
  </div>
</div>
